export default __webpack_public_path__ + "static/media/Cooling Tower Pipeline works.3c0ac9e9.jpg";